import Button from '../Button';
import style from './styles.module.scss';

const CardConfirm = ({ dadosAcao, dados, confirmar, cancelar }) => {
    return (
        <div className={style.card}>
            <table className={style.tableDadosAtividade}>
                <tbody>
                    <tr>
                        <td>Técnico responsável:</td>
                        <td>{dadosAcao.tecnico}</td>
                    </tr>
                    <tr>
                        <td>Ação:</td>
                        <td>{dadosAcao.acao}</td>
                    </tr>
                    <tr>
                        <td>Projeto:</td>
                        <td>{dadosAcao.projeto}</td>
                    </tr>
                    <tr>
                        <td>Código:</td>
                        <td>{dadosAcao.codigo}</td>
                    </tr>
                    <tr>
                        <td>Associação:</td>
                        <td>{dadosAcao.associacao}</td>
                    </tr>
                    <tr>
                        <td>Território:</td>
                        <td>{dadosAcao.territorio}</td>
                    </tr>
                    <tr>
                        <td>De:</td>
                        <td>{dadosAcao.data_inicio}</td>
                        <td>à</td>
                        <td>{dadosAcao.data_fim}</td>
                    </tr>
                </tbody>
            </table>

            <table className={style.tableArquivo}>
                <thead>
                    <tr>
                        <th>Nome</th>
                        <th>Gênero</th>
                        <th>Idade</th>
                        <th>Organização</th>
                        <th>CPF</th>
                    </tr>
                </thead>
                <tbody>
                    {/* Percorrer a lista de registros */}
                    {dados.map((row, index) => (
                        <tr key={index}>
                            <td>{row.nome}</td>
                            <td>{row.genero}</td>
                            <td>{row.idade}</td>
                            <td>{row.organizacao}</td>
                            <td>{row.cpf}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div className={style.containerBtts}>
                <Button onClick={confirmar} text={'Confirmar'}/>
                <Button className={style.cancelar} onClick={cancelar} text={'Cancelar'} initialModo={true}/>
            </div>
        </div>
    )
}

export default CardConfirm;
